import React, { useState } from 'react';
import { createPortal } from 'react-dom';

import styles from './styles.css';
import { attachStyles, isShadowDomAvailable } from './utils';

interface Props {
  shouldInheritColor: boolean;
  shouldInheritBg?: boolean;
  children: React.ReactElement;
}

export const ShadowView = ({
  shouldInheritColor,
  shouldInheritBg,
  children,
}: Props) => {
  const [shadowRoot, setShadowRoot] = useState<ShadowRoot | null>(null);
  const recordOfInheritedProperties = {
    color: shouldInheritColor,
    '--snippetTextColor': !!shouldInheritBg,
    '--snippetLinkTextColor': !!shouldInheritBg,
  };

  const setRoot = (element: HTMLElement | null) => {
    if (element && !element.shadowRoot) {
      const shadow = element.attachShadow({ mode: 'open' });
      attachStyles(shadow, recordOfInheritedProperties);
      setShadowRoot(shadow);
    }
  };

  return isShadowDomAvailable ? (
    <>
      {!shadowRoot && children}
      <span ref={setRoot} className={styles.containerPortal}>
        {shadowRoot && createPortal(children, shadowRoot as any)}
      </span>
    </>
  ) : (
    children
  );
};
